export default function normalizePrice(price: number | string): string {
  if (price === undefined) {
    return "-";
  }
  const cleanPrice =
    typeof price === "string" ? Number(price.replace("$", "")) : price;

  const isInteger = Number.isInteger(cleanPrice);

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: 2,
    currencyDisplay: "narrowSymbol",
  }).format(cleanPrice);
}

export const normalizePriceUsd = (price: number, isNeedPrefix = false) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
  }).format(price);
  return `${isNeedPrefix ? "$" : ""}${formatter} USD`;
};

export const normalizePriceDollar = (price: number) => {
  if (price === undefined) {
    return "N/A";
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
  }).format(price);
  return `$${formatter}`;
};
